import type { FaireProductEntity } from "../../entity_types/product";

export const p_wcms5d6y47: FaireProductEntity = {
  token: "p_wcms5d6y47",
  type: "product",
  name: "Apana Foot Massager – Assorted Color Therapy Ball",
  brandToken: "b_72ivqmkinu",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/67625b6687c52eda35eedf0b605abc8259594685ab5ef10f9d1da091518ff64d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/55d2c2192bc60c878a749fb268218e65ee12b58eac2b43b9bca7b7ddd852d1da.png",
    "https://cdn.faire.com/fastly/ad9b09bed65e66b45655fb8aefee54f73d1f0ca906517f3e376fc259c975a6a7.png",
    "https://cdn.faire.com/fastly/b47f4585810e9d74d8ed88796b9746138e09e98742afa21fa1dcb75497b18e36.png",
    "https://cdn.faire.com/fastly/e7d5a419216594121acfd3ef5f8bae2ef031e4eeecb66be108463b6d5ed3194e.jpeg",
    "https://cdn.faire.com/fastly/466abe9e8f2c3d5e3dd3720c43cd8ecf8ded25d90072805c532551c115098817.jpeg",
    "https://cdn.faire.com/fastly/47fb3efd2c38861582dea2014a59f92b83d3d8ee290b2930a1f4f62775ffe3d5.jpeg",
    "https://cdn.faire.com/fastly/c77e2a5d816870291adad84dcb03061f61d77961ceff5654850e8df8d17050d0.jpeg",
    "https://cdn.faire.com/fastly/c9eac670f469d503039b3877e5874f7e36a1f14d172be4b9a4b0e6c068d0e9cf.png",
  ],
  priceDollars: 4.51,
  description:
    "Apana Foot Massager helps relieve sore feet with a textured massage ball ideal for pre & post workout muscle therapy. Compact and easy to use at home, in the office, or at the gym, it’s great for rolling under the foot to target tension and support circulation.\n\nKey Features\n\nTextured foot massager ball for targeted relief\n\nDesigned for pre & post workout muscle massage therapy\n\nCan help relieve plantar fasciitis and soothe tense, sore muscles\n\nSimple roll-under-foot use—great at home, office, or gym\n\nAssorted colors for eye-catching retail displays\n\nOrdering Note\nPrice on Faire is per piece; items are sold in case packs of 48 foot massagers.",
  tags: [],
  msrpDollars: 9.01,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:47.924Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
